const ONBOARDING_DONE_KEY = 'psycheflow_webapp2_onboarding_done';

export function isOnboardingDone(): boolean {
  try {
    return sessionStorage.getItem(ONBOARDING_DONE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markOnboardingDone(): void {
  try {
    sessionStorage.setItem(ONBOARDING_DONE_KEY, '1');
  } catch {
    // ignore storage errors
  }
}
